export default "__VITE_ASSET__Cw9k6_rz__"